import { render, staticRenderFns } from "./ErrorBasic.vue?vue&type=template&id=c77b78fa&scoped=true&"
import script from "./ErrorBasic.vue?vue&type=script&lang=js&"
export * from "./ErrorBasic.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBasic.vue?vue&type=style&index=0&id=c77b78fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77b78fa",
  null
  
)

export default component.exports